import OzonAnalytics from '../../../../components/OzonAnalytics';

export default OzonAnalytics;
